module.exports = __webpack_public_path__ + "img/river-oaks-logo.b234bbf7.jpg";